import { IntegrationsProvider as CoreIntegrationsProvider } from '@components/integrations';
import type { ListQuery } from '@components/integrations/integrations-types';

import {
  authenticationTest,
  createEndpointsFromOpenAPI,
  createIntegration,
  createIntegrationEndpoint,
  createIntegrationWebhook,
  deleteIntegration,
  deleteIntegrationEndpoint,
  deleteIntegrationWebhook,
  duplicateIntegration,
  duplicateIntegrationEndpoint,
  duplicateIntegrationWebhook,
  generateJqQuery,
  integrationTestRequest,
  listSyncTestRequest,
  loadIntegration,
  loadIntegrationEndpoint,
  loadIntegrations,
  loadIntegrationWebhook,
  loadIntegrationWebhookLogs,
  parseOpenAPISpec,
  reorderIntegration,
  subscribeIntegrationWebhook,
  unsubscribeIntegrationWebhook,
  updateIntegration,
  updateIntegrationAuthentication,
  updateIntegrationEndpoint,
  updateIntegrationEndpointDefaultFiles,
  updateIntegrationEndpointExampleFiles,
  updateIntegrationWebhook,
  validateJqQuery,
} from 'api/integrations/requests';
import {
  loadLists,
  loadList,
  createList,
  editList,
  deleteList,
  createSyncList,
  patchSyncList,
  syncList,
  syncToManualList,
} from 'api/lists/requests';

const loadListsWrapper = async (params?: ListQuery) => {
  return loadLists(params?.search ?? '');
};

export const IntegrationsProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <CoreIntegrationsProvider
      value={{
        // Integration methods
        loadIntegration,
        loadIntegrations,
        createIntegration,
        deleteIntegration,
        loadIntegrationEndpoint,
        loadIntegrationWebhook,
        loadIntegrationWebhookLogs,
        createIntegrationEndpoint,
        updateIntegrationEndpoint,
        deleteIntegrationEndpoint,
        updateIntegrationEndpointExampleFiles,
        updateIntegrationEndpointDefaultFiles,
        updateIntegrationAuthentication,
        updateIntegration,
        authenticationTest,
        integrationTestRequest,
        duplicateIntegration,
        duplicateIntegrationEndpoint,
        duplicateIntegrationWebhook,
        validateJqQuery,
        generateJqQuery,
        createIntegrationWebhook,
        updateIntegrationWebhook,
        deleteIntegrationWebhook,
        subscribeIntegrationWebhook,
        unsubscribeIntegrationWebhook,
        parseOpenAPISpec,
        createEndpointsFromOpenAPI,
        reorderIntegration,

        // List methods
        loadLists: loadListsWrapper,
        loadList,
        createList,
        editList,
        deleteList,
        createSyncList,
        patchSyncList,
        syncList,
        syncToManualList,
        listSyncTestRequest,
      }}
    >
      {children}
    </CoreIntegrationsProvider>
  );
};
